import { render, staticRenderFns } from "./UserVerificationInternal.vue?vue&type=template&id=82af9a2c"
import script from "./UserVerificationInternal.vue?vue&type=script&lang=js"
export * from "./UserVerificationInternal.vue?vue&type=script&lang=js"
import style0 from "./UserVerificationInternal.vue?vue&type=style&index=0&id=82af9a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports